//------------------------------------------------------ funciones
import {
  subscribeTable,
  createRow,
  updateRow,
  deleteRow,
} from "../supabaseRealtime";
import { cacheStore } from "../cache";
import { etiquetaDeFicha } from "../../shared/empresa";
import { textoDeEstado, estaActiva } from "./estado";
import { etiquetaLona } from "../../shared/lona";
import { etiquetaTipo as etiquetaTipoAcoplado } from "../../shared/tipoAcoplado";
import { etiquetaTipoTaller } from "../../shared/tipoTaller";
import { etiquetaPuerta } from "../../shared/puerta";

const TABLA = "furgones";

const enriquecer = (fg) => {
  const empresasMap = cacheStore.empresas?.map || {};
  const empresa = empresasMap[String(fg.empresa)];

  // Ver estado.js: el campo trae "1"/"true"/"0"/"false"/""/null, y el
  // chequeo anterior daba "Activo" para todo texto no vacío — incluido
  // "false".
  const estado = textoDeEstado(fg.estado);

  /* Estadía abierta en el taller (#114), igual que en tractores. La clave
   * del taller para un furgón lleva la F adelante: `F308`. */
  const estadia = (cacheStore.enTaller?.data || []).find(
    (e) => String(e.interno) === "F" + String(fg.id),
  );

  return {
    ...fg,
    label: `${fg.id} (${fg.dominio})`.trim(),
    nombreEmpresa: etiquetaDeFicha(fg.empresa, empresa),
    estadoReal: estado,
    enTaller: Boolean(estadia),
    tallerMotivo: estadia?.motivo || null,
    /* La lona, ya traducida. Se deriva ACÁ y no en la tabla por el mismo
     * motivo que `estadoReal`: la columna guarda un valor y la pantalla
     * muestra una palabra, y con la traducción escrita en cada pantalla el
     * día que cambie una diría «Sin dato» y la otra «No». `lonaTexto` es lo
     * que ve la tabla; `lona` sigue crudo para el formulario. */
    lonaTexto: etiquetaLona(fg.lona),
    /* Igual que la lona: la tabla muestra el texto y el formulario sigue
     * viendo la clave cruda. Con la traducción escrita en los dos lados,
     * el día que cambie una diría «Sin dato» y la otra «Furgón». */
    tipoAcopladoTexto: etiquetaTipoAcoplado(fg.tipo_acoplado),
    /* LO QUE CARGA FEDERICO DESDE `/FurgonesApp`, que hasta ahora no se veía
     * en ninguna pantalla compartida.
     *
     * `tipoTallerTexto` NO es `tipoAcopladoTexto`: aquélla es la carrocería
     * que lee el alta de movimientos y ésta es cómo lo clasifica el taller
     * —prolongado, piso liso, pincen 120, randon 120—. Son dos columnas
     * porque son dos preguntas; ver `tipoTaller.js`. */
    tipoTallerTexto: etiquetaTipoTaller(fg.tipo_taller),
    puertaTexto: etiquetaPuerta(fg.puerta),
  };
};

export const subscribeFurgones = (callback) =>
  subscribeTable(TABLA, (rows) => callback(rows.map(enriquecer)));

/* Mismo problema que arriba: `x.estado` a secas daba verdadero para el
 * texto "false". Ahora se usa el mismo criterio que la etiqueta, para que
 * la lista y el contador no puedan discrepar. */
export const getFurgonesActivos = (lista) =>
  lista.filter((x) => estaActiva(x.estado));

export const createFurgon = ({ id, ...data }) => createRow(TABLA, id, data);

export const updateFurgon = (id, data) => updateRow(TABLA, id, data);

export const deleteFurgon = (id) => deleteRow(TABLA, id);
